import React from 'react';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { ContactAvatar } from '../contact_avatar/ContactAvatar';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { connect } from 'react-redux';
import {
	userNotificationsRestCrudThunksForBuyer,
	userNotificationsRestCrudThunksForSupplier,
} from '../../thunks/user_notifications_thunks';
import { withRouter } from 'react-router';
import Ellipsis from 'ant-design-pro/lib/Ellipsis';
import NotificationTemplate from './templates';
import { Avatar } from 'antd';
import { getAvatarStyle } from '../../utils/ImageUtils';
import { getLinkWIthBackLinkParams } from '../../utils/HistoryUtils';
import { getOnClickUrlFromNotification } from '../../utils/NotificationUtils';
import NotificationSubscriptionHandler from './NotificationSubscriptionHandler';

const moment = require('moment');

const UserNotificationRowDisplay: React.FC<any> = ({
	history,
	notification,
	userType,
	updateUserNotificationForBuyer,
	updateUserNotificationForSupplier,
	style,
	showTemplate = false,
	onUpdate,
	location,
}) => {
	const handleUserNotificationClick = () => {
		const notificationUrl = getOnClickUrlFromNotification(userType)(notification);
		const updateUserNotification =
			userType === ROLE_TYPES.BUYER
				? updateUserNotificationForBuyer
				: updateUserNotificationForSupplier;
		const newNotification = {
			...notification,
			hasSeen: true,
		};
		updateUserNotification(newNotification).then(() => {
			onUpdate && onUpdate();
		});
		if (notificationUrl && notificationUrl.length > 0) {
			history.push(getLinkWIthBackLinkParams(location, 'Back to Inbox', notificationUrl));
		}
	};

	if (!notification) {
		return null;
	}

	const hasContact = nullSafeGetOrElse(
		`${userType}PushNotification.initiatedBuyerContact`,
		notification,
		nullSafeGet(`${userType}PushNotification.initiatedSupplierContact`, notification)
	);
	const getInitialsfromNotification = (str = '') => {
		const words = str.split(' ');
		if (words.length > 1) {
			return words[0].charAt(0) + words[1].charAt(0);
		} else {
			return words[0].charAt(0);
		}
	};

	return (
		<>
			<div
				onClick={handleUserNotificationClick}
				style={{
					...style,
					fontWeight: `${notification.hasSeen}` === 'false' ? 'bold' : '',
				}}
				className="flex cursor-pointer grid-cols-3 flex-row gap-x-6 gap-y-3  text-gray-600"
			>
				<div className="flex-grow">
					<div className="flex w-full flex-row items-center justify-between">
						<div className="flex flex-row justify-between gap-2">
							<div className="shrink-0">
								{hasContact ? (
									<ContactAvatar
										size={20}
										userType={userType}
										contact={nullSafeGetOrElse(
											`${userType}PushNotification.initiatedBuyerContact`,
											notification,
											nullSafeGet(
												`${userType}PushNotification.initiatedSupplierContact`,
												notification
											)
										)}
									/>
								) : (
									<Avatar
										size={20}
										style={getAvatarStyle(getInitialsfromNotification(notification.title))}
									>
										{getInitialsfromNotification(notification.title)}
									</Avatar>
								)}
							</div>
							<div className="flex flex-nowrap items-baseline leading-snug">
								<Ellipsis tooltip fullWidthRecognition lines={1} className="text-lg">
									{notification.title}
								</Ellipsis>

								<div className="ml-2 flex items-center whitespace-nowrap text-sm text-gray-400">
									{moment(notification.datetime).fromNow()}
									{!notification.hasSeen && <span className="Notification_badge ml-2" />}
								</div>
							</div>
						</div>
						<NotificationSubscriptionHandler notification={notification} />
					</div>
					{showTemplate && <NotificationTemplate notification={notification} />}
				</div>
			</div>
		</>
	);
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
	updateUserNotificationForBuyer: (entity) =>
		dispatch(userNotificationsRestCrudThunksForBuyer.update(entity)),
	updateUserNotificationForSupplier: (entity) =>
		dispatch(userNotificationsRestCrudThunksForSupplier.update(entity)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserNotificationRowDisplay));
